import { Card } from "@/components/ui/card";
import { DollarSign, Briefcase, Activity, CheckCircle2, TrendingUp, Database } from "lucide-react";

export function OverviewTab() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-bold mb-2">Executive Overview</h2>
        <p className="text-muted-foreground">Key performance indicators across all systems</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Financial KPI */}
        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-success/10">
              <DollarSign className="w-6 h-6 text-success" />
            </div>
            <TrendingUp className="w-4 h-4 text-success" />
          </div>
          <p className="text-sm text-muted-foreground mb-1">Total Revenue</p>
          <p className="text-3xl font-bold">$0</p>
          <p className="text-xs text-muted-foreground mt-2">This month</p>
        </Card>

        {/* Jobs KPI */}
        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-primary/10">
              <Briefcase className="w-6 h-6 text-primary" />
            </div>
            <TrendingUp className="w-4 h-4 text-primary" />
          </div>
          <p className="text-sm text-muted-foreground mb-1">Active Jobs</p>
          <p className="text-3xl font-bold">0</p>
          <p className="text-xs text-muted-foreground mt-2">In progress</p>
        </Card>

        {/* Completion Rate KPI */}
        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-blue-500/10">
              <CheckCircle2 className="w-6 h-6 text-blue-500" />
            </div>
            <TrendingUp className="w-4 h-4 text-blue-500" />
          </div>
          <p className="text-sm text-muted-foreground mb-1">Completion Rate</p>
          <p className="text-3xl font-bold">0%</p>
          <p className="text-xs text-muted-foreground mt-2">This month</p>
        </Card>

        {/* Data Health KPI */}
        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-purple-500/10">
              <Database className="w-6 h-6 text-purple-500" />
            </div>
            <Activity className="w-4 h-4 text-purple-500" />
          </div>
          <p className="text-sm text-muted-foreground mb-1">Data Quality</p>
          <p className="text-3xl font-bold">95%</p>
          <p className="text-xs text-muted-foreground mt-2">Health score</p>
        </Card>

        {/* AI Success Rate KPI */}
        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-neon-purple/10">
              <Activity className="w-6 h-6 text-neon-purple" />
            </div>
            <TrendingUp className="w-4 h-4 text-neon-purple" />
          </div>
          <p className="text-sm text-muted-foreground mb-1">AI Success Rate</p>
          <p className="text-3xl font-bold">0%</p>
          <p className="text-xs text-muted-foreground mt-2">All analyses</p>
        </Card>

        {/* Forms Completed KPI */}
        <Card className="p-6">
          <div className="flex items-start justify-between mb-3">
            <div className="p-3 rounded-xl bg-neon-orange/10">
              <CheckCircle2 className="w-6 h-6 text-neon-orange" />
            </div>
            <TrendingUp className="w-4 h-4 text-neon-orange" />
          </div>
          <p className="text-sm text-muted-foreground mb-1">Forms Completed</p>
          <p className="text-3xl font-bold">0</p>
          <p className="text-xs text-muted-foreground mt-2">This month</p>
        </Card>
      </div>

      <Card className="p-6">
        <h3 className="text-lg font-semibold mb-4">Quick Insights</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-3 rounded-lg bg-muted/50">
            <span className="text-sm">Outstanding Payments</span>
            <span className="font-semibold">$0</span>
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg bg-muted/50">
            <span className="text-sm">Average Deal Cycle</span>
            <span className="font-semibold">0 days</span>
          </div>
          <div className="flex items-center justify-between p-3 rounded-lg bg-muted/50">
            <span className="text-sm">AI Analyses This Month</span>
            <span className="font-semibold">0</span>
          </div>
        </div>
      </Card>
    </div>
  );
}
